import { render } from "./auteurDetail.vue?vue&type=template&id=ce5c570c&scoped=true"
import script from "./auteurDetail.vue?vue&type=script&lang=js"
export * from "./auteurDetail.vue?vue&type=script&lang=js"

import "./auteurDetail.vue?vue&type=style&index=0&id=ce5c570c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce5c570c"]])

export default __exports__